import axios from 'axios';
import { url } from '../../config/config';

interface CallAuthorizeBackendOption {
  path: string;
  method?: 'POST' | 'GET';
  data?: any;
  executeDownload?: boolean;
  onSuccess?: (response: any) => void;
  onError?: (error: any) => void;
}

export const callAuthorizeBackend = (options: CallAuthorizeBackendOption) => {

  const path = options.path;

  axios({
    url: `${url}${path.charAt(0) !== '/' ? '/' : ''}${path}`,
    data: options.data,
    headers: {
      authorization: `${localStorage.getItem('token')}`
    },
    method: options.method || 'POST',
    responseType: 'blob'
  })
    .then(response => {
      // vyvolá stažení obsahu
      if (options.executeDownload === true) {
        const contentType = response.headers['content-type'];
        const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
        const link = document.createElement('a');

        link.setAttribute('download', response.headers['x-suggested-filename']);
        link.setAttribute('href', url);

        var clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: false
        });
        link.dispatchEvent(clickEvent);
      }

      if (options.onSuccess) {
        options.onSuccess(response);
      }
    })
    .catch(err => {
      if (options.onError) {
        options.onError(err);
      }
    });
};


// WEBPACK FOOTER //
// ./src/helpers/Backend/callAuthorizeBackend.ts